import { __spreadArray } from 'tslib';

var addTreeOption = function (folderId, options, treeOptions) {
    if (!treeOptions) {
        return options;
    }
    else if (!options || options.length === 0) {
        return treeOptions;
    }
    var returnTreeOption = true;
    options.forEach(function (opt) {
        if (opt.id === folderId && !opt.children) {
            opt.children = treeOptions;
            returnTreeOption = false;
        }
        else if (opt.children) {
            addTreeOption(folderId, opt.children, treeOptions);
            returnTreeOption = false;
        }
    });
    if (returnTreeOption) {
        return treeOptions;
    }
    else {
        return __spreadArray([], options, true);
    }
};
var updateLoadingState = function (options, optionId, loadingStateToApply) {
    if (!optionId) {
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            option.childrenLoading = loadingStateToApply;
            if (option.children) {
                updateLoadingState(option.children, optionId, loadingStateToApply);
            }
        }
    }
    else {
        for (var _a = 0, options_2 = options; _a < options_2.length; _a++) {
            var option = options_2[_a];
            if (!optionId || option.id === optionId) {
                option.childrenLoading = loadingStateToApply;
            }
            else if (option.children) {
                updateLoadingState(option.children, optionId, loadingStateToApply);
            }
        }
    }
};

export { addTreeOption, updateLoadingState };
//# sourceMappingURL=utils.js.map
